import React, { createContext, ReactNode, useCallback, useContext, useState } from 'react';
import { HBToast, ToastProps } from '@honeybook/hbui';
import ClientOnly from 'components/ClientOnly';
import { toastInteractionMessage } from 'lib/client/services/postMessageService';

interface IContextProps {
    addToast: (toast: ToastProps) => void;
    removeToast: (id: string) => void;
    removeAllToasts: () => void;
}

const ToastContext = createContext<IContextProps>({} as IContextProps);

export const useToast = () => {
    return useContext(ToastContext);
};

export const ToastProvider = ({ children }: { children: ReactNode }) => {
    const [toasts, setToasts] = useState<ToastProps[]>([]);

    const removeAllToasts = useCallback(() => {
        toastInteractionMessage({ isOpen: false });
        setToasts([]);
    }, []);

    const removeToast = useCallback((id: string) => {
        toastInteractionMessage({ isOpen: false });
        setToasts(prevState => prevState.filter(toast => toast.id !== id));
    }, []);

    const addToast = useCallback((toast: ToastProps) => {
        toastInteractionMessage({ isOpen: true });
        const id = toast.id || String(Math.random());
        setToasts(prevState => [...prevState, { ...toast, id }]);
    }, []);

    return (
        <ToastContext.Provider value={{ addToast, removeToast, removeAllToasts }}>
            <ClientOnly>
                <HBToast toasts={toasts} removeItem={removeToast} />
            </ClientOnly>
            {children}
        </ToastContext.Provider>
    );
};
